import { html } from 'lit';

export const iconMinusCircle = html`
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="9" cy="9" r="9" fill="currentColor" />
    <path
      d="M12.7812 9.5625H5.21875C4.83203 9.5625 4.53125 9.26172 4.53125 8.875C4.53125 8.50977 4.83203 8.1875 5.21875 8.1875H12.7812C13.1465 8.1875 13.4688 8.50977 13.4688 8.875C13.4688 9.26172 13.1465 9.5625 12.7812 9.5625Z"
      fill="white"
    />
  </svg>
`;
